<template>
<div style="max-height: 350px;overflow-y: auto">
  <el-table
    v-loading="loading"
    size="mini"
    :data="tableData"
    border
    style="width: 100%;"
    highlight-current-row>
    <el-table-column
      type="index"
      label="序号"
      width="50"
      align="center">
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      min-width="60"
      align="center">
    </el-table-column>
    <el-table-column
      label="性别"
      width="50"
      align="center">
      <template slot-scope="scope">
        <span>{{getSex(scope.row.sex)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="birthday"
      label="出生日期"
      min-width="70"
      align="center">
    </el-table-column>
    <el-table-column
      prop="phone"
      label="电话号码"
      min-width="90"
      align="center">
    </el-table-column>
    <el-table-column
      prop="timelist"
      label="接听电话时间段"
      min-width="90"
      align="center">
    </el-table-column>
    <el-table-column
      prop="circumstances"
      label="特殊情况"
      min-width="90"
      align="center">
    </el-table-column>
  </el-table>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {queryoldpersonbyhids} from '../../../api/handlealarm'

export default {
  name: 'homePersons',
  props: {
    homeObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      tableData: []
    }
  },
  created () {
    this.getOldPersonByHome()
  },
  methods: {
    getOldPersonByHome () {
      this.loading = true
      let data = {
        hids: [this.homeObj.id]
      }
      queryoldpersonbyhids(data).then(res => {
        this.tableData = res.data.persons
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/homePersons.vue